// features/videos/useVideoTheater.ts — tiny Zustand store for the video watch page's
// theater-mode toggle. Mirrors app/shell/useRailCollapsed.ts exactly (own localStorage
// key, no persist middleware, try/catch around storage access) — see that file's header
// comment for why this shape (transient chrome state, not a personalization axis).

import { create } from 'zustand';

const KEY = 'truxsocial:videoTheater';

function readInitial(): boolean {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    // localStorage unavailable (SSR/quota) — default to the two-column layout
    return false;
  }
}

function persist(v: boolean): void {
  try {
    localStorage.setItem(KEY, v ? '1' : '0');
  } catch {
    // localStorage unavailable — ignore
  }
}

interface VideoTheaterState {
  theater: boolean;
  toggle: () => void;
  set: (v: boolean) => void;
}

export const useVideoTheater = create<VideoTheaterState>((set) => ({
  theater: readInitial(),
  toggle: () =>
    set((s) => {
      const next = !s.theater;
      persist(next);
      return { theater: next };
    }),
  set: (v) =>
    set(() => {
      persist(v);
      return { theater: v };
    }),
}));
